import { useTranslation } from 'react-i18next';
import { ListingPrice, Address, Attributes } from '~/components/ListingCard';
import { InlineCardProps } from '~/components/ListingCard/types';
import { RoutesEnum } from '~/constants/enums';

export default function InlineCard({ listing, className }: InlineCardProps) {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;
  const listingRoute = `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LISTING}/${listing.id}-${listing.slug}`;

  return (
    <div
      className={`flex w-full overflow-hidden rounded-[10px] bg-white   ${className}`}
    >
      <div className="relative w-[120px] flex-shrink-0 overflow-hidden">
        <a
          href={listingRoute}
          target="_blank"
          className="flex h-full"
          rel="noopener noreferrer"
        >
          {listing.photo && listing.photo !== '' ? (
            <img
              src={listing.photo}
              alt={listing.title}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray">
              <div className="flex justify-center items-center w-[48px] h-[48px]">
                <i className="inline-block bg-cover image-placeholder-icon w-full h-full" />
              </div>
            </div>
          )}
        </a>
      </div>

      <a
        href={listingRoute}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col gap-1.5x p-1.5x w-full min-w-0 h-full"
      >
        <ListingPrice
          price={listing.price}
          section={listing.section.slug}
          area={listing.area}
        />
        <div className="flex flex-col gap-x max-w-full min-w-0">
          <Address address={listing.address ?? ''} className="text-justify" />

          <Attributes
            listing={{
              area: listing.area,
              attributes: {
                rooms: listing.attributes?.rooms
                  ? parseInt(listing.attributes.rooms, 10)
                  : undefined,
                baths: listing.attributes?.baths
                  ? parseInt(listing.attributes.baths, 10)
                  : undefined,
              },
            }}
          />
        </div>
      </a>
    </div>
  );
}
